export default ({
  field = 'password',
  compareField = 'reTypePassword',
  customError = null,
  customRequiredMessage = null // New parameter for custom required message
}) => {
  return {
    [field]: {
      presence: {
        allowEmpty: false,
        message: customRequiredMessage || '^ Required' // Use custom message if provided
      },
      equality: {
        attribute: compareField,
        message: customError || '^ Passwords do not match.'
      }
    }
  };
};
